import { IContract } from "@rentiohq/shared-frontend/dist/types/contract.types";
import { IProperty } from "@rentiohq/shared-frontend/dist/types/property.types";

export interface IExtraData {
  property: IProperty;
  contract: IContract;
  previousContract?: IContract;
  energyTransferByMexp?: boolean;
}

export enum EField {
  MoveDate = "moveDate",
  NoContract = "noContract",
  ResidentCount = "residentCount",
  DepartingTenant = "departingTenantAccountId",
  NewTenant = "newTenantAccountId",
  Services = "services",

  DepartingTenantTitle = "departingTenantTitle",
  DepartingTenantFirstName = "departingTenantFirstName",
  DepartingTenantLastName = "departingTenantLastName",
  DepartingTenantEmail = "departingTenantEmail",
}
